export enum OpenCashDrawerOptions {
  AFTER_CASH_PAYMENT = 1,
  AFTER_EVERY_SALE = 2,
  NEVER = 3,
}
